import styled from "styled-components";

export const LeftSideBoldSpan = styled.span`
  font-weight: 600;
`;

export const LeftSideRightSpan = styled.span`
  margin-left: auto;
`;
